import { type ErrorComponentProps, Link } from "@tanstack/react-router"
import { Button } from "@/shared/components/ui/button"
import { ApiError } from "@/shared/utils/apiError"

// Router-level fallback for errors no route catches. A 401 means the session
// died mid-use (expired cookie, logout elsewhere) — offer login instead of a crash.
export function RouterErrorScreen({ error }: ErrorComponentProps) {
  const isUnauthorized = error instanceof ApiError && error.status === 401

  return (
    <main className="flex min-h-dvh flex-col items-center justify-center gap-6 bg-background px-6 text-center">
      <p className="text-lg font-semibold text-foreground">
        {isUnauthorized ? "Du har blivit utloggad" : "Något gick fel"}
      </p>
      {isUnauthorized ? (
        <Button asChild>
          <Link to="/login">Logga in</Link>
        </Button>
      ) : (
        <Button onClick={() => window.location.reload()}>Ladda om</Button>
      )}
    </main>
  )
}
